import React from 'react';
import { Box, IconButton, Typography, Drawer, Stack } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { DRAWER_WIDTH } from '@/constants';

interface SideDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    subtitle?: string | null;
    children: React.ReactNode;
    closeButtonAriaLabel?: string;
    testId?: string;
}

/**
 * Component that renders a provided content in a side drawer panel.
 *
 * @param {SideDrawerProps} props
 * @returns {JSX.Element}
 */
const SideDrawer: React.FC<SideDrawerProps> = (props) => {
    const { isOpen = false, onClose, title, subtitle = null, children, testId = 'side-drawer', closeButtonAriaLabel = 'Close' } = props;

    return (
        <Drawer variant="persistent" anchor="right" open={isOpen} onClose={onClose} aria-expanded={isOpen} data-testid={testId}>
            <Box sx={{ width: DRAWER_WIDTH }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        p: 2,
                        pr: 1,
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Stack direction="column" gap={0.25}>
                        <Typography variant="h4">{title}</Typography>
                        {subtitle && (
                            <Typography variant="body2" color="text.secondary">
                                {subtitle}
                            </Typography>
                        )}
                    </Stack>
                    <Box>
                        <IconButton onClick={onClose} aria-label={closeButtonAriaLabel}>
                            <ChevronRight />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ overflow: 'auto', maxWidth: DRAWER_WIDTH }}>{children && children}</Box>
        </Drawer>
    );
};

export default SideDrawer;
